import RoutingActions from '../../actions/RoutingActions';
import GuestActions from '../../actions/GuestActions';
import NotificationActions from '../../actions/NotificationActions';

import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';

import { endPoints as GuestListEndpoints } from '../../constants/GuestListConstants';

import AjaxPromises from '../../utils/AjaxPromises'

import InputProfile from '../profile/view/InputProfile.react';
import DropdownProfile from '../profile/view/DropdownProfile.react';
import DOBProfile from '../profile/view/DOBProfile.react';

class NewProfile extends React.Component {

    constructor(props) {
        super(props);

        // TODO :: camel case
        this.state = {
            biotrackId : ''
        };

        this.onChange = this.onChange.bind(this);
        this.validateById = this.validateById.bind(this);
    }

    onChange(field, val) {
        this.setState({ [field] : val });
    }

    validateById() {
        var self             = this;
        var formData         = UserStore.getApiData();
        formData.PatientScan = this.state.biotrackId;
        formData.ScanSession = formData.sessionId;

        if (this.state.biotrackId.length < 6)
            return;
        
        AjaxPromises.POST(GuestListEndpoints.BIOTRACK_VALIDATE_USER,
            formData).then(res =>  {

                if (res.Result === 'true') {
                    NotificationActions.addNotification({
                        type : 'success',
                        body : res.Message,
                        fullscreen : true,
                        sticky : true
                    }); 
                } else {
                    NotificationActions.addNotification({
                        type : 'error',
                        body : res.Message
                    });                    
                }
            }
        );
    }

    render() {
        var self = this;
        var page = this.props.page;

        if (page !== 'biotrack')
            return null;

        return (
            <div
                className='new-profile'>

                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='profile-main__container--header'>
                                Validate Biotrack Customer by ID
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='biotrackId'
                                value={this.state.biotrackId}
                                onChange={this.onChange}
                                placeHolder='ID to validate' />
                        </div>
                        <div className='col-6'>
                            <div 
                                className={'new-profile__save btn-green '+(this.state.biotrackId.length > 6 ? '' : 'btn-green__disabled')}
                                onClick={this.validateById}>

                                Validate
                            </div>
                        </div>
                    </div>            
                </div>
            </div>
        );
    }
}

export default NewProfile;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLBiotrack.react.jsx